module.exports = __webpack_public_path__ + "static/fonts/PorscheNext-Thin.87e440ed.otf";